import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, StarIcon } from './icons/Icons';
export const WhyUs = () => {
  const comparisonData = [{
    other: 'Tratamientos genéricos "para toda piel"',
    us: 'Protocolo personalizado para TU piel'
  }, {
    other: 'Atención rápida sin seguimiento',
    us: 'María Fernanda conoce tu piel y tu historia'
  }, {
    other: 'Productos de stock sin análisis previo',
    us: 'Evaluación real antes de cada procedimiento'
  }, {
    other: 'Resultados temporales',
    us: 'Transformación visible y progresiva'
  }, {
    other: 'Solo un servicio estético',
    us: 'Esthetician + Medical Assistant — doble expertise'
  }, {
    other: 'Un spa más en Filadelfia',
    us: 'El studio donde Philadelphia se transforma'
  }];
  const reasons = [{
    title: 'RESULTADOS VISIBLES',
    desc: 'No trabajamos con promesas vacías. Cada tratamiento está diseñado para que veas la diferencia — muchas desde la primera sesión.'
  }, {
    title: 'TECNOLOGÍA AVANZADA',
    desc: 'Laser, PRP, Dermapen, IV Therapy — utilizamos las tecnologías más efectivas del mercado, aplicadas con precisión y cuidado.'
  }, {
    title: 'PRODUCTOS DE ALTA CALIDAD',
    desc: 'Solo utilizamos productos probados, seguros y de alta performance — porque tu piel merece lo mejor, no lo más barato.'
  }];
  return <section id="por-que" className="py-12 md:py-16 bg-brand-pink relative" data-id="element-422">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-423">
        <div className="text-center mb-8 md:mb-10" data-id="element-424">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-425">
            Por Qué Skin Glow Studio 22
          </h2>
          <p className="text-xl text-brand-bronze font-serif italic" data-id="element-426">
            No todos los studios son iguales. Este es diferente.
          </p>
        </div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-2xl shadow-sm border border-brand-gold/20 overflow-hidden mb-10 md:mb-12" data-id="element-427">
          <div className="grid grid-cols-2 bg-brand-blush border-b border-brand-gold/20" data-id="element-428">
            <div className="p-6 text-center border-r border-brand-gold/20" data-id="element-429">
              <h3 className="text-sm md:text-base font-medium text-brand-charcoal/60 uppercase tracking-wider" data-id="element-430">
                Lo que encuentras en otros lugares
              </h3>
            </div>
            <div className="p-6 text-center bg-brand-gold/5" data-id="element-431">
              <h3 className="text-sm md:text-base font-medium text-brand-bronze uppercase tracking-wider" data-id="element-432">
                Lo que encuentras en Skin Glow Studio 22
              </h3>
            </div>
          </div>

          <div className="divide-y divide-brand-cream" data-id="element-433">
            {comparisonData.map((row, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-brand-blush/30 transition-colors" data-id="element-434">
                <div className="p-4 md:p-6 border-r border-brand-cream flex items-center space-x-3" data-id="element-435">
                  <div className="text-brand-charcoal/30 flex-shrink-0" data-id="element-436">
                    <XIcon size={18} data-id="element-437" />
                  </div>
                  <span className="text-sm md:text-base text-brand-charcoal/70" data-id="element-438">
                    {row.other}
                  </span>
                </div>
                <div className="p-4 md:p-6 flex items-center space-x-3 bg-brand-gold/5" data-id="element-439">
                  <div className="text-brand-gold flex-shrink-0" data-id="element-440">
                    <CheckIcon size={18} data-id="element-441" />
                  </div>
                  <span className="text-sm md:text-base font-medium text-brand-charcoal" data-id="element-442">
                    {row.us}
                  </span>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* 3 Reasons */}
        <div className="text-center mb-6" data-id="element-443">
          <p className="text-lg font-medium text-brand-charcoal flex items-center justify-center space-x-4" data-id="element-444">
            <span className="h-px w-8 bg-brand-gold" data-id="element-445"></span>
            <span data-id="element-446">Tres razones por las que confiar en nosotras:</span>
            <span className="h-px w-8 bg-brand-gold" data-id="element-447"></span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-448">
          {reasons.map((reason, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="text-center p-6" data-id="element-449">
              <div className="w-12 h-12 mx-auto rounded-full bg-brand-blush border border-brand-gold/30 flex items-center justify-center text-brand-gold mb-6" data-id="element-450">
                <span className="font-serif text-xl" data-id="element-451">{idx + 1}</span>
              </div>
              <h4 className="text-lg font-medium text-brand-charcoal mb-4 tracking-wide" data-id="element-452">
                {reason.title}
              </h4>
              <p className="text-brand-charcoal/70 leading-relaxed text-sm" data-id="element-453">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};